<template>
    <div class="row">
        <div class="card">
            <div class="card-header">
                <div class="flex flex-row justify-between">
                    <h2 class="ml-5">
                        Lista de valores do Boleto dos Sindicatos
                    </h2>
                    <button
                        @click="
                            $router.push(
                                '/sistema/boletos/nova-configuracoes-boleto'
                            )
                        "
                        class="ml-1 bg-transparent hover:bg-red-600 text-red-600 font-semibold hover:text-white py-2 px-2 border border-red-600 hover:border-transparent rounded"
                    >
                        Adicionar Configuração
                    </button>
                </div>
            </div>
            <div class="card-body">
                <vue-good-table
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-per-page-change="onPerPageChange"
                    ref="vue-good-table"
                    :columns="configuracoes.columns"
                    :rows="configuracoes.rows"
                    :totalRows="configuracoes.total"
                    :responsive="true"
                    :pagination-options="{
                        enabled: true,
                        perPage: 10,
                        nextLabel: 'Próximo',
                        prevLabel: 'Anterior',
                        rowsPerPageLabel: 'Resultados por página',
                        ofLabel: 'de',
                        pageLabel: 'página',
                        allLabel: 'Todos'
                    }"
                    styleClass="vgt-table striped"
                >
                    <div slot="emptystate">
                        <div class="text-center">
                            <p>Nenhum evento foi contratado ainda.</p>
                        </div>
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div
                            v-if="props.column.field === 'acoes'"
                            class="flex flex-row justify-around"
                        >
                            <input
                                v-model="novo_valor"
                                class="shadow appearance-none border rounded w-full py-1 px-3 text-gray-500 leading-tight focus:outline-none focus:shadow-outline"
                                type="text"
                                placeholder="Novo valor"
                            />
                            <button
                                @click="
                                    atualizar(
                                        props.row.configuracao_boleto_id,
                                        props.row.sindicato_id
                                    )
                                "
                                class="ml-1 bg-transparent hover:bg-red-600 text-red-600 font-semibold hover:text-white py-2 px-2 border border-red-600 hover:border-transparent rounded"
                            >
                                <svg-icon icon="save" />
                            </button>
                        </div>
                        <span>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
export default {
    name: "tabela-configuracoes",

    components: {
        VueGoodTable
    },

    created() {
        this.getConfiguracoesBoleto();
    },

    data() {
        return {
            novo_valor: "",
            configuracoes: {
                columns: [
                    { label: "Nome", field: "nome_completo" },
                    { label: "Email", field: "email" },
                    { label: "Telefone", field: "telefone" },
                    { label: "Valor Atual", field: "valor_boleto" },
                    {
                        label: "Ações",
                        field: "acoes",
                        filterable: false,
                        sortable: false
                    }
                ],
                rows: [],
                total: 0,
                filtros: {
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    page: 1,
                    perPage: 10
                }
            }
        };
    },

    methods: {
        /**
         * Altera a paginação
         * @param params
         */
        onPageChange(params) {
            this.filtrarEventos({ page: params.currentPage });
        },

        /**
         * Filtra pela coluna conforme ascendente/descendente
         * @param params
         */
        onSortChange(params) {
            this.filtrarEventos({
                sort: {
                    type: params[0].type,
                    field: params[0].field
                }
            });
        },

        /**
         * Altera a quantidade de registros por página
         * @param params
         */
        onPerPageChange(params) {
            this.filtrarEventos({ perPage: params.currentPerPage });
        },

        /**
         * Filtra os configuracoes conforme as mudanças
         * @param newProps
         */
        filtrarEventos(newProps) {
            this.configuracoes.filtros = Object.assign(
                {},
                this.configuracoes.filtros,
                newProps
            );
            this.getNoticias();
        },

        getConfiguracoesBoleto() {
            this.axios("configuracoes-boleto", {
                params: {
                    page: this.configuracoes.filtros.page,
                    per_page: this.configuracoes.filtros.perPage,
                    sortField: this.configuracoes.filtros.sort.field,
                    sortType: this.configuracoes.filtros.sort.type
                }
            }).then(response => {
                this.configuracoes.rows = response.data.configuracaoBoleto.data;
                this.configuracoes.total =
                    response.data.configuracaoBoleto.total;
            });
        },

        atualizar(id, sindicato) {
            this.axios
                .post("configuracoes-boleto", {
                    id: id,
                    valor_boleto: this.novo_valor,
                    sindicato_id: sindicato
                })
                .then(response => {
                    this.getConfiguracoesBoleto();
                    this.$swal({
                        title: "Sucesso",
                        text: "A configuração foi excluido.!",
                        type: "success"
                    });
                })
                .catch(error => {
                    this.$swal({
                        title: "Algo de errado ocorreu",
                        text: error.response.data.message,
                        type: "error"
                    });
                });
        },

        excluirConfiguracoes(id) {
            this.$swal({
                title: "Excluir Configurações do Boleto",
                text: "Você deseja excluir esta configuração?",
                type: "question",
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonColor: "#6C9E1D",
                cancelButtonColor: "#E50053",
                cancelButtonText: "Não",
                confirmButtonText: "Sim"
            }).then(result => {
                if (result.value) {
                    this.axios
                        .delete(`/configuracoes-boleto/${id}`)
                        .then(response => {
                            this.getConfiguracoesBoleto();
                            this.$swal({
                                title: "Sucesso",
                                text: "A configuração foi excluido.!",
                                type: "success"
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                title: "Algo de errado ocorreu",
                                text: error.response.data.message,
                                type: "error"
                            });
                        });
                }
            });
        }
    }
};
</script>
